var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossEyeFileverseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 140,
    viewBox: "0 0 120 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Animation placeholder"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 49.6816,
    y: 2,
    width: 68.3179,
    height: 88.1854,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_2",
    x: 40.1465,
    y: 11.5365,
    width: 68.3179,
    height: 88.1854,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_3",
    x: 30.6094,
    y: 21.0729,
    width: 68.3179,
    height: 88.1854,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_4",
    x: 21.0723,
    y: 30.6092,
    width: 68.3179,
    height: 88.1854,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_5",
    x: 11.5371,
    y: 40.1456,
    width: 68.3179,
    height: 88.1854,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape_6",
    x: 2,
    y: 49.6821,
    width: 68.3179,
    height: 88.1854,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    d: "M21.8677 107.106C21.8677 103.101 23.4585 99.2607 26.2902 96.429C29.1219 93.5974 32.9625 92.0065 36.9671 92.0065C40.9717 92.0065 44.8122 93.5974 47.6439 96.429C50.4756 99.2607 52.0664 103.101 52.0664 107.106L36.9671 107.106L21.8677 107.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2247",
    x: 16,
    y: 72.1215,
    width: 3,
    height: 14,
    transform: "rotate(-45 16 72.1215)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2249",
    x: 37,
    y: 72.1215,
    width: 3,
    height: 14,
    transform: "rotate(-45 37 72.1215)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2248",
    width: 3,
    height: 14,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 28.0215 72.1212)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2250",
    width: 3,
    height: 14,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 49.0215 72.1215)",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossEyeFileverseLogo);
export default __webpack_public_path__ + "static/media/cross-eye-fileverse-logo.477a019fed636f95b0e63bedb3ad8409.svg";
export { ForwardRef as ReactComponent };